import {createAction} from 'redux-act';

export const GET_SUCCESS_MANAGER = createAction(
  'successManager/GET_SUCCESS_MANAGER'
);
export const GET_SUCCESS_MANAGER_SUCCESS = createAction(
  'successManager/GET_SUCCESS_MANAGER_SUCCESS'
);
